import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocalizationContext } from '@im/react-localization';

type Props = {
  description: string;
  image: string;
  pageurl?: string;
  title: string;
};

export const MetaDatataConfig = ({
  description,
  image,
  pageurl,
  title,
}: Props) => {
  const locale = useLocalizationContext();
  const pageUrl = pageurl ?? window.location.href;
  const culture = locale.locale.toString().split('-').join('_');
  let PageTitle = 'Xvantage';
  if (title) {
    PageTitle = `${title} | Xvantage`;
  }
  return (
    <Helmet>
      <title>{PageTitle} </title>
      <link href={pageUrl} rel="canonical"></link>
      <meta content={description} name="description" />
      <meta content={locale.locale} name="Language" />
      <meta content={locale.locale} name="Content-Language" />
      <meta content="Xvantage" name="application-name" />
      <meta content={PageTitle} property="og:title" />
      <meta content="Xvantage" property="og:site_name" />
      <meta content={pageUrl} property="og:url" />
      <meta content={description} property="og:description" />
      <meta content={image} property="og:image" />
      <meta content={culture} property="og:locale"></meta>
    </Helmet>
  );
};
